import { BrowserModule } from '@angular/platform-browser';
import { NgModule, ErrorHandler, APP_INITIALIZER } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';

import * as Sentry from "@sentry/angular";

import {IPTVEditorModule} from "./includes/IPTV_Editor/iptv_editor.module";
import { DynamicComponentsModule } from "./includes/dynamic_components/dynamic.module";


import {Ajax} from "./services/ajax.service";
import {StoreService} from "./services/store.service";

import { AppComponent } from './app.component';
import { IPTVChannelComponent } from './iptv.channel.component';
import { IptvVideoComponent } from './includes/iptv-video/iptv-video.component';
import { TextEditorComponent } from "./text-editor.component";
import { EpgWindowComponent } from "./includes/iptv-epg/epg_window.component";
import { EpgWindowService } from "./includes/iptv-epg/epg_window.service";
import { epgDayChangedPipe } from "./includes/iptv-epg/epg_day_changed.pipe";
import { UploadFormComponent } from "./upload.form.component";
import { IPTVVideoService } from "./includes/iptv-video/iptv-video.service";
import { HelpComponent } from "./help.component";
import { DemoMessageComponent } from "./demo-message.component";


@NgModule({
  declarations: [
    AppComponent, IPTVChannelComponent, IptvVideoComponent, TextEditorComponent, HelpComponent, DemoMessageComponent,
    EpgWindowComponent, epgDayChangedPipe,
    UploadFormComponent
  ],
  imports: [
    BrowserModule, FormsModule, IPTVEditorModule, HttpClientModule, DynamicComponentsModule,
    RouterModule.forRoot([
      { path: '', component: AppComponent },]),
  ],
  providers: [Ajax, StoreService, IPTVVideoService, EpgWindowService,
    {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler({
        // Показывает диалоговое окно для отправки ошибки.
        showDialog: false,
      }),
    },
    {
      provide: Sentry.TraceService,
      deps: [Router],
    },
    {
      provide: APP_INITIALIZER,
      useFactory: () => () => {},
      deps: [Sentry.TraceService],
      multi: true,
    },
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
